import { InvoiceDetailsView } from "@portal/BaseComponents/DetailsView/InvoiceDetailsView/InvoiceDetailsView";
import { InvoiceFilters } from "@portal/Components/Portal/PotalTabs/Invoice/Filters/InvoiceFilters";
import { InvoiceList } from "@portal/Components/Portal/PotalTabs/Invoice/InvoiceList";
import { useGetInvoiceStatusesConfig } from "@portal/Components/Portal/PotalTabs/Invoice/useInvoiceStatusesConfig";
import { useFeatures } from "@portal/hooks/use-features";
import { useFormats } from "@portal/hooks/use-formats";
import { usePrivileges } from "@portal/hooks/use-privilleges";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { Provider } from "jotai";
import { useParams } from "react-router-dom";

function InvoiceListPage() {
  const { invoice_id } = useParams<AppPageParams>();
  const { getDisputePrivilege, getPTPPrivilege, getCFPrivileges } =
    usePrivileges();
  const { getDraftFeatures } = useFeatures();
  const invoiceStatusOptions = useGetInvoiceStatusesConfig();
  const { extra } = useFormats();
  return (
    <>
      <Provider>
        <InvoiceFilters
          actionFeatures={{
            draftInvoice: getDraftFeatures("DRAFT_INVOICE"),
            draftMetric: getDraftFeatures("DRAFT_METRICS"),
          }}
          invoiceStatusConfig={invoiceStatusOptions}
        />
        <InvoiceList
          actionPrivileges={{
            dispute: getDisputePrivilege("DISPUTE_CREATE"),
            ptp: getPTPPrivilege("PTP_CREATE"),
            customField: getCFPrivileges("CUSTOM_FIELD_LIST_VIEW"),
          }}
          invoiceStatusConfig={invoiceStatusOptions}
          extra={extra}
        />
      </Provider>
      <InvoiceDetailsView id={invoice_id} open={Boolean(invoice_id)} />
    </>
  );
}

export { InvoiceListPage };
